export default __webpack_public_path__ + "static/media/zoomin_icon_bold.e73708ff.svg";